import { render, staticRenderFns } from "./AugmentedReality.vue?vue&type=template&id=43e35866&scoped=true&"
import script from "./AugmentedReality.vue?vue&type=script&lang=js&"
export * from "./AugmentedReality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e35866",
  null
  
)

export default component.exports